export enum ToolbarEvent {
  none=0, new=1, edit=2, save=3, cancel=4, delete=5, clear=6, addNote=7, checkChange = 8
}

